var map = {
	"./13to24/bg32.png": "./src/EGRContent/Story/AsalSathi/images/13to24/bg32.png",
	"./13to24/bg32.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/bg32.svg",
	"./13to24/bg32a-filled.png": "./src/EGRContent/Story/AsalSathi/images/13to24/bg32a-filled.png",
	"./13to24/bg32a.png": "./src/EGRContent/Story/AsalSathi/images/13to24/bg32a.png",
	"./13to24/bg33.png": "./src/EGRContent/Story/AsalSathi/images/13to24/bg33.png",
	"./13to24/bg_tortlelookingfromtop.png": "./src/EGRContent/Story/AsalSathi/images/13to24/bg_tortlelookingfromtop.png",
	"./13to24/bg_tortlelookingfromtop.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/bg_tortlelookingfromtop.svg",
	"./13to24/bgsample.png": "./src/EGRContent/Story/AsalSathi/images/13to24/bgsample.png",
	"./13to24/bubble - Copy.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/bubble - Copy.svg",
	"./13to24/bubble.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/bubble.svg",
	"./13to24/cloud-fs.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/cloud-fs.svg",
	"./13to24/cloud01.png": "./src/EGRContent/Story/AsalSathi/images/13to24/cloud01.png",
	"./13to24/cloud01.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/cloud01.svg",
	"./13to24/cloud02.png": "./src/EGRContent/Story/AsalSathi/images/13to24/cloud02.png",
	"./13to24/cloud02.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/cloud02.svg",
	"./13to24/cloud03.png": "./src/EGRContent/Story/AsalSathi/images/13to24/cloud03.png",
	"./13to24/cloud03.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/cloud03.svg",
	"./13to24/clouds.png": "./src/EGRContent/Story/AsalSathi/images/13to24/clouds.png",
	"./13to24/clouds.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/clouds.svg",
	"./13to24/duckwithstick.png": "./src/EGRContent/Story/AsalSathi/images/13to24/duckwithstick.png",
	"./13to24/duckwithstick.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/duckwithstick.svg",
	"./13to24/fall.gif": "./src/EGRContent/Story/AsalSathi/images/13to24/fall.gif",
	"./13to24/flying.gif": "./src/EGRContent/Story/AsalSathi/images/13to24/flying.gif",
	"./13to24/flying.png": "./src/EGRContent/Story/AsalSathi/images/13to24/flying.png",
	"./13to24/flying.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/flying.svg",
	"./13to24/hill.png": "./src/EGRContent/Story/AsalSathi/images/13to24/hill.png",
	"./13to24/hill.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/hill.svg",
	"./13to24/hill01.png": "./src/EGRContent/Story/AsalSathi/images/13to24/hill01.png",
	"./13to24/hill01.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/hill01.svg",
	"./13to24/kachuwa.png": "./src/EGRContent/Story/AsalSathi/images/13to24/kachuwa.png",
	"./13to24/kachuwa01.png": "./src/EGRContent/Story/AsalSathi/images/13to24/kachuwa01.png",
	"./13to24/kachuwa02.png": "./src/EGRContent/Story/AsalSathi/images/13to24/kachuwa02.png",
	"./13to24/kachuwa03.png": "./src/EGRContent/Story/AsalSathi/images/13to24/kachuwa03.png",
	"./13to24/new_bg.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/new_bg.svg",
	"./13to24/page03bg.png": "./src/EGRContent/Story/AsalSathi/images/13to24/page03bg.png",
	"./13to24/page03bg.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/page03bg.svg",
	"./13to24/page04_bg.png": "./src/EGRContent/Story/AsalSathi/images/13to24/page04_bg.png",
	"./13to24/page04_bg.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/page04_bg.svg",
	"./13to24/sky.png": "./src/EGRContent/Story/AsalSathi/images/13to24/sky.png",
	"./13to24/sky.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/sky.svg",
	"./13to24/spacer.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/spacer.svg",
	"./13to24/stars.png": "./src/EGRContent/Story/AsalSathi/images/13to24/stars.png",
	"./13to24/sun.png": "./src/EGRContent/Story/AsalSathi/images/13to24/sun.png",
	"./13to24/sun.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/sun.svg",
	"./13to24/three_flying.png": "./src/EGRContent/Story/AsalSathi/images/13to24/three_flying.png",
	"./13to24/three_flying.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/three_flying.svg",
	"./13to24/tortle_body.png": "./src/EGRContent/Story/AsalSathi/images/13to24/tortle_body.png",
	"./13to24/tortle_body.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/tortle_body.svg",
	"./13to24/tortle_head.png": "./src/EGRContent/Story/AsalSathi/images/13to24/tortle_head.png",
	"./13to24/tortle_head.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/tortle_head.svg",
	"./13to24/tortlelookingfromtop.png": "./src/EGRContent/Story/AsalSathi/images/13to24/tortlelookingfromtop.png",
	"./13to24/tortlelookingfromtop.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/tortlelookingfromtop.svg",
	"./13to24/tortoise06.png": "./src/EGRContent/Story/AsalSathi/images/13to24/tortoise06.png",
	"./13to24/tortoise06.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/tortoise06.svg",
	"./13to24/tortoise07.png": "./src/EGRContent/Story/AsalSathi/images/13to24/tortoise07.png",
	"./13to24/tortoise07.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/tortoise07.svg",
	"./13to24/tortoise08.png": "./src/EGRContent/Story/AsalSathi/images/13to24/tortoise08.png",
	"./13to24/tortoise08.svg": "./src/EGRContent/Story/AsalSathi/images/13to24/tortoise08.svg",
	"./13to24/tree_flying.png": "./src/EGRContent/Story/AsalSathi/images/13to24/tree_flying.png",
	"./1to5/bg.png": "./src/EGRContent/Story/AsalSathi/images/1to5/bg.png",
	"./1to5/bush01.png": "./src/EGRContent/Story/AsalSathi/images/1to5/bush01.png",
	"./1to5/bush02.png": "./src/EGRContent/Story/AsalSathi/images/1to5/bush02.png",
	"./1to5/cloud01.png": "./src/EGRContent/Story/AsalSathi/images/1to5/cloud01.png",
	"./1to5/cloud02.png": "./src/EGRContent/Story/AsalSathi/images/1to5/cloud02.png",
	"./1to5/cloud03.png": "./src/EGRContent/Story/AsalSathi/images/1to5/cloud03.png",
	"./1to5/pond-from-top.png": "./src/EGRContent/Story/AsalSathi/images/1to5/pond-from-top.png",
	"./1to5/pond.svg": "./src/EGRContent/Story/AsalSathi/images/1to5/pond.svg",
	"./1to5/sathi-guff.png": "./src/EGRContent/Story/AsalSathi/images/1to5/sathi-guff.png",
	"./1to5/sky-empty.png": "./src/EGRContent/Story/AsalSathi/images/1to5/sky-empty.png",
	"./1to5/sun.png": "./src/EGRContent/Story/AsalSathi/images/1to5/sun.png",
	"./25to33/bg01.png": "./src/EGRContent/Story/AsalSathi/images/25to33/bg01.png",
	"./25to33/bg01.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/bg01.svg",
	"./25to33/ducks.png": "./src/EGRContent/Story/AsalSathi/images/25to33/ducks.png",
	"./25to33/flying01.png": "./src/EGRContent/Story/AsalSathi/images/25to33/flying01.png",
	"./25to33/flying01.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/flying01.svg",
	"./25to33/goingdown01.png": "./src/EGRContent/Story/AsalSathi/images/25to33/goingdown01.png",
	"./25to33/goingdown01.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/goingdown01.svg",
	"./25to33/goingdown02.png": "./src/EGRContent/Story/AsalSathi/images/25to33/goingdown02.png",
	"./25to33/goingdown02.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/goingdown02.svg",
	"./25to33/img01.png": "./src/EGRContent/Story/AsalSathi/images/25to33/img01.png",
	"./25to33/img01.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/img01.svg",
	"./25to33/img02.png": "./src/EGRContent/Story/AsalSathi/images/25to33/img02.png",
	"./25to33/img02.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/img02.svg",
	"./25to33/img03.png": "./src/EGRContent/Story/AsalSathi/images/25to33/img03.png",
	"./25to33/img03.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/img03.svg",
	"./25to33/page06_bg - Copy - Copy.png": "./src/EGRContent/Story/AsalSathi/images/25to33/page06_bg - Copy - Copy.png",
	"./25to33/page06_bg - Copy.png": "./src/EGRContent/Story/AsalSathi/images/25to33/page06_bg - Copy.png",
	"./25to33/page06_bg - Copy.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/page06_bg - Copy.svg",
	"./25to33/page06_bg.png": "./src/EGRContent/Story/AsalSathi/images/25to33/page06_bg.png",
	"./25to33/page06_bg.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/page06_bg.svg",
	"./25to33/sweat.png": "./src/EGRContent/Story/AsalSathi/images/25to33/sweat.png",
	"./25to33/sweat.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/sweat.svg",
	"./25to33/three.png": "./src/EGRContent/Story/AsalSathi/images/25to33/three.png",
	"./25to33/three.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/three.svg",
	"./25to33/tortile.png": "./src/EGRContent/Story/AsalSathi/images/25to33/tortile.png",
	"./25to33/tortle02.png": "./src/EGRContent/Story/AsalSathi/images/25to33/tortle02.png",
	"./25to33/tortle02.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/tortle02.svg",
	"./25to33/tortle_body.png": "./src/EGRContent/Story/AsalSathi/images/25to33/tortle_body.png",
	"./25to33/tortle_body.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/tortle_body.svg",
	"./25to33/tortle_head.png": "./src/EGRContent/Story/AsalSathi/images/25to33/tortle_head.png",
	"./25to33/tortle_head.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/tortle_head.svg",
	"./25to33/tortle_on_back.png": "./src/EGRContent/Story/AsalSathi/images/25to33/tortle_on_back.png",
	"./25to33/tortle_on_back.svg": "./src/EGRContent/Story/AsalSathi/images/25to33/tortle_on_back.svg",
	"./6to10/bg.png": "./src/EGRContent/Story/AsalSathi/images/6to10/bg.png",
	"./6to10/duck01a.png": "./src/EGRContent/Story/AsalSathi/images/6to10/duck01a.png",
	"./6to10/duck01a.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/duck01a.svg",
	"./6to10/duck01b.png": "./src/EGRContent/Story/AsalSathi/images/6to10/duck01b.png",
	"./6to10/duck01b.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/duck01b.svg",
	"./6to10/duck01c.png": "./src/EGRContent/Story/AsalSathi/images/6to10/duck01c.png",
	"./6to10/duck01c.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/duck01c.svg",
	"./6to10/duck01e.png": "./src/EGRContent/Story/AsalSathi/images/6to10/duck01e.png",
	"./6to10/duck01e.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/duck01e.svg",
	"./6to10/duck02a.png": "./src/EGRContent/Story/AsalSathi/images/6to10/duck02a.png",
	"./6to10/duck02a.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/duck02a.svg",
	"./6to10/duck02b.png": "./src/EGRContent/Story/AsalSathi/images/6to10/duck02b.png",
	"./6to10/duck02b.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/duck02b.svg",
	"./6to10/duck02c.png": "./src/EGRContent/Story/AsalSathi/images/6to10/duck02c.png",
	"./6to10/duck02c.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/duck02c.svg",
	"./6to10/duck02d.png": "./src/EGRContent/Story/AsalSathi/images/6to10/duck02d.png",
	"./6to10/duck02d.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/duck02d.svg",
	"./6to10/ducks-turtle.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/ducks-turtle.svg",
	"./6to10/page02-bg.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/page02-bg.svg",
	"./6to10/pond-big-bg.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/pond-big-bg.svg",
	"./6to10/threefriends.png": "./src/EGRContent/Story/AsalSathi/images/6to10/threefriends.png",
	"./6to10/threefriends.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/threefriends.svg",
	"./6to10/tortoise.png": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise.png",
	"./6to10/tortoise.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise.svg",
	"./6to10/tortoise01.png": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise01.png",
	"./6to10/tortoise01.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise01.svg",
	"./6to10/tortoise03.png": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise03.png",
	"./6to10/tortoise03.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise03.svg",
	"./6to10/tortoise04.png": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise04.png",
	"./6to10/tortoise04.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise04.svg",
	"./6to10/tortoise05.png": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise05.png",
	"./6to10/tortoise05.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/tortoise05.svg",
	"./6to10/uselessHuge.svg": "./src/EGRContent/Story/AsalSathi/images/6to10/uselessHuge.svg",
	"./common/khusi-sathi.png": "./src/EGRContent/Story/AsalSathi/images/common/khusi-sathi.png",
	"./common/pokhari-bg.png": "./src/EGRContent/Story/AsalSathi/images/common/pokhari-bg.png",
	"./coverpage.png": "./src/EGRContent/Story/AsalSathi/images/coverpage.png",
	"./thumbnail.png": "./src/EGRContent/Story/AsalSathi/images/thumbnail.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/AsalSathi/images sync recursive ^\\.\\/.*$";